import type { Theme } from './types'

export const themeLocalStorageKey = 'payload-theme'

// Keep this for backward compatibility, but it should be used carefully
export const defaultTheme: Theme = 'light'

export const getImplicitPreference = (): Theme | null => {
  const mediaQuery = '(prefers-color-scheme: dark)'
  const mql = window.matchMedia(mediaQuery)
  const hasImplicitPreference = typeof mql.matches === 'boolean'

  if (hasImplicitPreference) {
    return 'light'
  }

  return null
}
